(function () {
  if (window.__quickAddInitialized) return;
  window.__quickAddInitialized = true;

  const DEBOUNCE_MS = 500;

  // ---- NEW: suppress cart drawer when form has data-hide-cart-drawer="true" ----
  window.__suppressCartDrawer = false;

  function patchCartDrawer() {
    const cartDrawer = document.querySelector('cart-drawer');
    if (!cartDrawer || cartDrawer.__patchedShow) return;

    const originalShow = cartDrawer.show.bind(cartDrawer);
    cartDrawer.show = function (activeElement) {
      if (window.__suppressCartDrawer) return;
      return originalShow(activeElement);
    };
    cartDrawer.__patchedShow = true;
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', patchCartDrawer);
  } else {
    patchCartDrawer();
  }

  // document.addEventListener(
  //   'submit',
  //   function (e) {
  //     const form = e.target.closest('[data-type="add-to-cart-form"]');
  //     if (!form) return;
  //     if (form.dataset.hideCartDrawer !== 'true') return;

  //     patchCartDrawer(); // in case cart-drawer wasn't in DOM yet at load

  //     window.__suppressCartDrawer = true;
  //     clearTimeout(window.__suppressCartDrawerTimer);
  //     window.__suppressCartDrawerTimer = setTimeout(() => {
  //       window.__suppressCartDrawer = false;
  //     }, 8000);
  //   },
  //   true
  // );
  // ---- END NEW ----

  function getState(wrapper) {
    if (!wrapper._quickAddState) {
      wrapper._quickAddState = {
        added: false,
        lineKey: null,
        timer: null,
        qty: 1
      };
    }
    return wrapper._quickAddState;
  }

  async function addToCart(variantId, quantity) {
    const res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: variantId, quantity })
    });
    if (!res.ok) throw new Error('Add to cart failed');
    return res.json();
  }

  async function changeLineQuantity(lineKey, quantity) {
    const res = await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: lineKey, quantity })
    });
    if (!res.ok) throw new Error('Update cart failed');
    return res.json();
  }

  async function getFreshCart() {
    const cartUrl = (window.FoxTheme && FoxTheme.routes && FoxTheme.routes.cart_url) || '/cart.js';
    const res = await fetch(cartUrl, { headers: { Accept: 'application/json' } });
    return res.json();
  }

  async function syncThemeCart(openDrawer) {
    const cartJson = await getFreshCart();

    if (window.FoxTheme && FoxTheme.pubsub) {
      FoxTheme.pubsub.publish(FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate, { cart: cartJson });
    }

    document.dispatchEvent(
      new CustomEvent('cart:refresh', {
        bubbles: true,
        detail: { open: !!openDrawer }
      })
    );

    return cartJson;
  }

  function syncQuantity(wrapper, variantId) {
    const state = getState(wrapper);
    clearTimeout(state.timer);
    state.timer = setTimeout(async () => {
      try {
        await changeLineQuantity(state.lineKey, state.qty);
        await syncThemeCart(false);
      } catch (err) {
        console.error(err);
      }
    }, DEBOUNCE_MS);
  }

  document.addEventListener('submit', function (e) {
    const form = e.target.closest('[data-type="add-to-cart-form"]');
    if (!form) return;

    const wrapper = form.closest('.quick-add_form');
    const state = getState(wrapper);

    if (state.added) return;

    e.preventDefault();
    e.stopImmediatePropagation();

    form.querySelector('[type="submit"]').style.display = 'none';
    wrapper.querySelector('.quick-add-qty').style.display = 'flex';

    state.qty = 1;
    wrapper.querySelector('.quick-add-quantity').value = 1;
    wrapper.querySelector('.qty-value').textContent = 1;

    const variantId = wrapper.querySelector('.product-variant-id').value;
    (async () => {
      try {
        const line = await addToCart(variantId, 1);
        state.added = true;
        state.lineKey = line.key;
        await syncThemeCart(form.dataset.hideCartDrawer !== 'true');
      } catch (err) {
        console.error(err);
      }
    })();
  }, true);

  document.addEventListener('click', function (e) {
  const isPlus = e.target.closest('.qty-plus');
  const isMinus = e.target.closest('.qty-minus');
  if (!isPlus && !isMinus) return;

  const wrapper = e.target.closest('.quick-add_form');
  if (!wrapper) return;

  const state = getState(wrapper);
  const variantId = wrapper.querySelector('.product-variant-id').value;

  if (isPlus) {
    state.qty += 1;

    wrapper.querySelector('.quick-add-quantity').value = state.qty;
    wrapper.querySelector('.qty-value').textContent = state.qty;

    syncQuantity(wrapper, variantId);
    return;
  }

  // Minus button
  if (state.qty === 1) {
    (async () => {
      try {
        // Remove item from cart
        await changeLineQuantity(state.lineKey, 0);

        // Refresh cart
        await syncThemeCart(false);

        // Reset state
        clearTimeout(state.timer);
        state.added = false;
        state.lineKey = null;
        state.qty = 1;

        // Reset UI
        wrapper.querySelector('.quick-add-qty').style.display = 'none';
        wrapper.querySelector('[type="submit"]').style.display = '';

        wrapper.querySelector('.quick-add-quantity').value = 1;
        wrapper.querySelector('.qty-value').textContent = 1;
      } catch (err) {
        console.error(err);
      }
    })();

    return;
  }

  // Decrease quantity
  state.qty -= 1;

  wrapper.querySelector('.quick-add-quantity').value = state.qty;
  wrapper.querySelector('.qty-value').textContent = state.qty;

  syncQuantity(wrapper, variantId);
});
})();